import React from 'react';
import loadable from '@loadable/component';
import { ConsentManager } from '@browsing/tracking';
import { ErrorBoundary } from '../../error-boundary';
var LazyChatBox = loadable(function () { return import(/* webpackChunkName: "browsing-chat-box" */ './chat-box'); });
export var ChatBox = function (_a) {
    var customer = _a.customer;
    return (React.createElement(ErrorBoundary, { componentName: "ChatBox" },
        React.createElement(ConsentManager, { serviceId: "salesforce_live_agent_lounge" },
            React.createElement(LazyChatBox, { customer: customer }))));
};
